import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { OfflineBanner } from './OfflineBanner';
import { ActingAsBanner } from './ActingAsBanner';
import { RequireAuth } from './RequireAuth';
import { useIdleLogout } from './useIdleLogout';

export function AppShell() {
    return (
        <RequireAuth>
            <AppShellInner />
        </RequireAuth>
    );
}

function AppShellInner() {
    // Runs inside RequireAuth so the hook only mounts for authenticated sessions.
    useIdleLogout();
    // The sidebar renders for everyone — it gates its own items per-role.
    // Parents see just two nav targets (Parent Portal + Support Center);
    // staff see the full clinical/operations/admin tree.
    // Mobile-only drawer state. Below md: the sidebar is hidden by default and
    // the topbar shows a hamburger; tapping it opens the drawer. Above md: the
    // sidebar is in-flow and this flag is ignored.
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    return (
        <div className="flex h-screen bg-background overflow-hidden">
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-3 focus:py-1.5 focus:bg-surface focus:text-text focus:rounded focus:shadow-md focus:outline-2 focus:outline-accent"
            >
                Skip to main content
            </a>
            <Sidebar
                mobileOpen={mobileNavOpen}
                onMobileClose={() => setMobileNavOpen(false)}
            />
            <div className="flex-1 min-w-0 flex flex-col">
                <TopBar
                    showMobileNav
                    onMobileNavOpen={() => setMobileNavOpen(true)}
                />
                <ActingAsBanner />
                <OfflineBanner />
                <main
                    id="main-content"
                    tabIndex={-1}
                    className="flex-1 overflow-auto [scrollbar-gutter:stable] focus:outline-none"
                >
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
